import { View, Text } from "react-native";
import React, { useState } from "react";
import * as Linking from "expo-linking";

import { danger, kalbasiMaybe, orange, primary, success, white } from "../../colors";
import MyText from "../custom/MyText";
import { TouchableOpacity } from "react-native";
import MyButton from "../custom/MyButton";

export default function Request({
  id,
  status,
  adminNote,
  title,
  description,
  links,
  onEdit,
  onDelete,
}) {
  const [deleteStep, setDeleteStep] = useState(1);
  const deleteRequest = () => {
    if (deleteStep === 1) {
      setDeleteStep(2);
    } else {
      onDelete(id);
    }
  };
  return (
    <View
      style={{
        width: "100%",
        marginTop: 10,
        borderWidth: 1,
        borderColor: "#eee",
        borderRadius: 10,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <View>
        <View
          style={{
            borderBottomRightRadius: 10,
            borderBottomLeftRadius: 10,
            padding: 5,
            backgroundColor:
              status === "pending"
                ? orange
                : status === "accept"
                ? success
                : danger,
            width: 150,
            marginHorizontal: 15,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text style={{ color: white }}>
            {status === "pending"
              ? "در انتظار تایید"
              : status === "accept"
              ? "تایید شده"
              : "رد شده"}
          </Text>
        </View>
      </View>
      <View style={{ padding: 10, marginTop: 20 }}>
        <MyText
          style={{
            fontSize: 15,
            backgroundColor: "#e0efef",
            padding: 5,
            borderRadius: 10,
            textAlign: "center",
          }}
        >
          عنوان
        </MyText>
        <MyText style={{ padding: 15, textAlign: "center" }}>{title}</MyText>
        <MyText
          style={{
            fontSize: 15,
            backgroundColor: "#e0efef",
            padding: 5,
            borderRadius: 10,
            textAlign: "center",
          }}
        >
          توضیحات
        </MyText>
        <MyText style={{ padding: 15, textAlign: "center" }}>
          {description}
        </MyText>
        <MyText
          style={{
            fontSize: 15,
            backgroundColor: "#e0efef",
            padding: 5,
            borderRadius: 10,
            textAlign: "center",
          }}
        >
          لینک ها
        </MyText>
        {links.map((item, index) => (
          <TouchableOpacity key={index} onPress={() => Linking.openURL(item)}>
            <Text style={{ padding: 15, textAlign: "center", color: primary }}>
              {item}
            </Text>
          </TouchableOpacity>
        ))}

        {adminNote !== undefined && adminNote !== null && (
          <View>
            <MyText
              style={{
                fontSize: 15,
                backgroundColor: "#e0efef",
                padding: 5,
                borderRadius: 10,
                textAlign: "center",
              }}
            >
              توضیحات ادمین
            </MyText>
            <MyText
              style={{ padding: 15, textAlign: "center" }}
            >{`${adminNote}`}</MyText>
          </View>
        )}
      </View>
      {status === "pending" && deleteStep === 1 && (
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            paddingHorizontal: 10,
            paddingVertical: 5,
            justifyContent: "flex-end",
          }}
        >
          <MyButton
            onPress={deleteRequest}
            style={{ backgroundColor: danger, marginHorizontal: 5 }}
            textStyle={{ fontSize: 12 }}
            text="حذف درخواست"
          />
          <MyButton
            onPress={() => onEdit()}
            textStyle={{ fontSize: 12 }}
            style={{ backgroundColor: orange, marginHorizontal: 5 }}
            text="ویرایش درخواست"
          />
        </View>
      )}
      {status === "pending" && deleteStep === 2 && (
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            paddingHorizontal: 10,
            paddingVertical: 5,
            justifyContent: "flex-end",
          }}
        >
          <MyButton
            onPress={() => setDeleteStep(1)}
            textStyle={{ fontSize: 12 }}
            style={{ backgroundColor: primary, marginHorizontal: 5 }}
            text="لغو"
          />
          <MyButton
            onPress={deleteRequest}
            style={{ backgroundColor: danger, marginHorizontal: 5 }}
            textStyle={{ fontSize: 12 }}
            text="تایید حذف"
          />
        </View>
      )}
    </View>
  );
}
